export const environment = {
  production: false,
  apiUrl: "https://api.ppe.news-solutions.refinitiv.com",
};
